import { SiteLink } from "shared/components/SiteLink";
import { EmailIcon, LocationIcon, PhoneIcon } from "shared/components/Icons";
import { MaxWidth } from "shared/components/MaxWidth";
import {
  SMALL,
  EMAIL_TYPE,
  PHONE_TYPE,
  LOCATION_TYPE,
} from "shared/utils/constants";
import { SrcSet } from "shared/components/SrcSet";
import { useAppContext } from "shared/utils/useAppContext";
import styles from "./ContactCard.module.css";

export const ContactCardContainer = ({
  description,
  image,
  link,
  meta,
  name,
  title,
}) => (
  <div className="ContactCardContainer">
    <MaxWidth size={SMALL}>
      <ContactCard
        description={description}
        image={image}
        link={link}
        meta={meta}
        name={name}
        title={title}
      />
    </MaxWidth>
  </div>
);

export const ContactCard = ({
  description,
  image,
  link,
  meta,
  name,
  title,
}) => {
  const { scope } = useAppContext();

  return (
    <div className={styles.container}>
      {title && <h2 className={styles.title}>{title}</h2>}

      <div className={styles.wrapper}>
        {image && (
          <SrcSet
            className={styles.image}
            alt={name}
            src={image}
            sizes={[
              { minWidth: 768, width: 88, ratio: 1 },
              { minWidth: 1, width: 64, ratio: 1 },
            ]}
          />
        )}

        <div className={styles.content}>
          {name && (
            <h3 className={styles.name}>
              {link ? (
                <SiteLink
                  {...link}
                  isOutOfScope={
                    scope.toLowerCase() !== link?.type?.split(".")[0]
                  }
                >
                  {name}
                </SiteLink>
              ) : (
                name
              )}
            </h3>
          )}

          {description && <p className={styles.description}>{description}</p>}

          {meta && (
            <ul className={styles.meta}>
              {meta
                .filter((item) => item.label)
                .map(({ label, type }) => (
                  <ContactCardMeta key={label} label={label} type={type} />
                ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

const ContactCardMeta = ({ label, type }) => {
  const hrefs = {
    [EMAIL_TYPE]: `mailto:${label}`,
    [PHONE_TYPE]: `tel:${label.replace(/\s-/g, "")}`,
  };

  const icons = {
    [EMAIL_TYPE]: EmailIcon,
    [LOCATION_TYPE]: LocationIcon,
    [PHONE_TYPE]: PhoneIcon,
  };

  const href = hrefs[type];
  const Icon = icons[type];
  const Element = href ? "a" : "span";

  return (
    <li className={styles.metaItem}>
      <Element href={href}>
        <span className={styles.iconContainer}>
          <Icon />
        </span>
        <span className={styles.label}>{label}</span>
      </Element>
    </li>
  );
};
